module.exports = __webpack_public_path__ + "img/logos.0d008409.gif";